function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1932(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24.27,
    height: 15.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6183333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 7.855,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 15.71,
    width: 24.27,
    height: 19.1,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1833333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 25.26,
    fontFamily: "Arial"
  }, "\n        Hardin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 34.8,
    width: 24.27,
    height: 20.76,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9657142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 45.18,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 55.56,
    width: 24.27,
    height: 22.11,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.5275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 66.61500000000001,
    fontFamily: "Arial"
  }, "\n        Pope\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 77.68,
    width: 24.27,
    height: 23.66,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.732
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 89.51,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 101.33,
    width: 24.27,
    height: 24.98,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.467142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 113.82,
    fontFamily: "Arial"
  }, "\n        Edwards\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 126.31,
    width: 24.27,
    height: 25.28,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6966666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 138.95,
    fontFamily: "Arial"
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 151.59,
    width: 24.27,
    height: 26.86,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.854
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 165.02,
    fontFamily: "Arial"
  }, "\n        Stark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 178.45,
    width: 24.27,
    height: 28.46,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.854
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 192.67999999999998,
    fontFamily: "Arial"
  }, "\n        Scott\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 206.91,
    width: 24.27,
    height: 28.52,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.03375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 221.17,
    fontFamily: "Arial"
  }, "\n        Gallatin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 235.43,
    width: 24.27,
    height: 28.8,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.467142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 249.83,
    fontFamily: "Arial"
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 264.23,
    width: 24.27,
    height: 30.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.467142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 279.66,
    fontFamily: "Arial"
  }, "\n        Kendall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 295.09,
    width: 24.27,
    height: 31.54,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 310.85999999999996,
    fontFamily: "Arial"
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 326.64,
    width: 24.27,
    height: 32.74,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.045
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 343.01,
    fontFamily: "Arial"
  }, "\n        Massac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 359.37,
    width: 24.27,
    height: 34.5,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.045
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 376.62,
    fontFamily: "Arial"
  }, "\n        Menard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 393.87,
    width: 24.27,
    height: 35.13,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.03375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 411.435,
    fontFamily: "Arial"
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 429.01,
    width: 24.27,
    height: 35.96,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.045
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 446.99,
    fontFamily: "Arial"
  }, "\n        Jersey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 464.96,
    width: 24.27,
    height: 37.08,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.045
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 483.5,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 502.05,
    width: 24.27,
    height: 39.21,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.03375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 521.655,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 541.25,
    width: 24.27,
    height: 39.38,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.03375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 560.94,
    fontFamily: "Arial"
  }, "\n        Moultrie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 580.63,
    width: 24.27,
    height: 39.67,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.045
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 600.465,
    fontFamily: "Arial"
  }, "\n        Wabash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 620.3,
    width: 24.27,
    height: 39.85,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.045
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 640.2249999999999,
    fontFamily: "Arial"
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 660.15,
    width: 24.27,
    height: 39.85,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.467142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.135,
    y: 680.0749999999999,
    fontFamily: "Arial"
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 0,
    width: 29.71,
    height: 33.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.4275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.125,
    y: 16.84,
    fontFamily: "Arial"
  }, "\n        Bond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.97,
    y: 0,
    width: 30.66,
    height: 33.68,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.3,
    y: 16.84,
    fontFamily: "Arial"
  }, "\n        Richland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.64,
    y: 0,
    width: 31.36,
    height: 33.68,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 100.32,
    y: 16.84,
    fontFamily: "Arial"
  }, "\n        Marshall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.99,
    y: 0,
    width: 31.78,
    height: 33.68,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.356
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.88,
    y: 16.84,
    fontFamily: "Arial"
  }, "\n        Piatt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.77,
    y: 0,
    width: 32.34,
    height: 33.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.468000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.94,
    y: 16.84,
    fontFamily: "Arial"
  }, "\n        Boone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.11,
    y: 0,
    width: 32.52,
    height: 33.68,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.13
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.37,
    y: 16.84,
    fontFamily: "Arial"
  }, "\n        Ford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.63,
    y: 0,
    width: 33.84,
    height: 33.68,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.368
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 229.55,
    y: 16.84,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 246.46,
    y: 0,
    width: 34.43,
    height: 33.68,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.42
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 263.675,
    y: 16.84,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.89,
    y: 0,
    width: 35.16,
    height: 33.68,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.811428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 298.46999999999997,
    y: 16.84,
    fontFamily: "Arial"
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.05,
    y: 0,
    width: 35.44,
    height: 33.68,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.736
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 333.77,
    y: 16.84,
    fontFamily: "Arial"
  }, "\n        Mason\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 351.49,
    y: 0,
    width: 36.27,
    height: 33.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.811428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 369.625,
    y: 16.84,
    fontFamily: "Arial"
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 387.76,
    y: 0,
    width: 36.32,
    height: 33.68,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.42
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 405.92,
    y: 16.84,
    fontFamily: "Arial"
  }, "\n        Cass\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 424.08,
    y: 0,
    width: 37.72,
    height: 33.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.613333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 442.94,
    y: 16.84,
    fontFamily: "Arial"
  }, "\n        Mercer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 461.8,
    y: 0,
    width: 38.79,
    height: 33.68,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.736
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 481.195,
    y: 16.84,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 500.58,
    y: 0,
    width: 39.24,
    height: 33.68,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 520.1999999999999,
    y: 16.84,
    fontFamily: "Arial"
  }, "\n        Woodford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.83,
    y: 0,
    width: 39.7,
    height: 33.68,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.736
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 559.6800000000001,
    y: 16.84,
    fontFamily: "Arial"
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 579.52,
    y: 0,
    width: 39.77,
    height: 33.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.613333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 599.405,
    y: 16.84,
    fontFamily: "Arial"
  }, "\n        Grundy\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619.29,
    y: 0,
    width: 39.85,
    height: 33.68,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.613333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 639.2149999999999,
    y: 16.84,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 659.15,
    y: 0,
    width: 40.85,
    height: 33.68,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7422222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 679.5749999999999,
    y: 16.84,
    fontFamily: "Arial"
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 33.68,
    width: 39.57,
    height: 35.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.016
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.055,
    y: 51.22,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 68.76,
    width: 39.57,
    height: 35.15,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.858333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.055,
    y: 86.33500000000001,
    fontFamily: "Arial"
  }, "\n        DeWitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 103.91,
    width: 39.57,
    height: 35.9,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.055,
    y: 121.86,
    fontFamily: "Arial"
  }, "\n        Clark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 139.81,
    width: 39.57,
    height: 36.98,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6979999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.055,
    y: 158.3,
    fontFamily: "Arial"
  }, "\n        Jo_Daviess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 176.79,
    width: 39.57,
    height: 37.94,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.7425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.055,
    y: 195.76,
    fontFamily: "Arial"
  }, "\n        Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 214.73,
    width: 39.57,
    height: 38.03,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.432857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.055,
    y: 233.745,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 252.75,
    width: 39.57,
    height: 38.27,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.252222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.055,
    y: 271.885,
    fontFamily: "Arial"
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 291.03,
    width: 39.57,
    height: 39.24,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.905
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.055,
    y: 310.65,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 330.27,
    width: 39.57,
    height: 40.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.055,
    y: 350.72499999999997,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 371.17,
    width: 39.57,
    height: 41.79,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.914
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.055,
    y: 392.065,
    fontFamily: "Arial"
  }, "\n        Perry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 412.96,
    width: 39.57,
    height: 44.91,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.652857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.055,
    y: 435.41499999999996,
    fontFamily: "Arial"
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 457.87,
    width: 39.57,
    height: 45.24,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.8925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.055,
    y: 480.49,
    fontFamily: "Arial"
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 503.12,
    width: 39.57,
    height: 47.12,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.055,
    y: 526.68,
    fontFamily: "Arial"
  }, "\n        Shelby\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 550.24,
    width: 39.57,
    height: 49.59,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.94625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.055,
    y: 575.035,
    fontFamily: "Arial"
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 599.83,
    width: 39.57,
    height: 49.9,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.652857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.055,
    y: 624.7800000000001,
    fontFamily: "Arial"
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 649.73,
    width: 39.57,
    height: 50.27,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.914
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.055,
    y: 674.865,
    fontFamily: "Arial"
  }, "\n        Edgar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.84,
    y: 33.68,
    width: 42.17,
    height: 47.43,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.5425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.92500000000001,
    y: 57.394999999999996,
    fontFamily: "Arial"
  }, "\n        Ogle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.01,
    y: 33.68,
    width: 42.76,
    height: 47.43,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.751111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 127.39,
    y: 57.394999999999996,
    fontFamily: "Arial"
  }, "\n        McDonough\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.77,
    y: 33.68,
    width: 42.79,
    height: 47.43,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.558
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 170.16500000000002,
    y: 57.394999999999996,
    fontFamily: "Arial"
  }, "\n        Logan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.56,
    y: 33.68,
    width: 45.49,
    height: 47.43,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.054444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.305,
    y: 57.394999999999996,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 237.05,
    y: 33.68,
    width: 45.96,
    height: 47.43,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.32
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 260.03000000000003,
    y: 57.394999999999996,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.01,
    y: 33.68,
    width: 48.19,
    height: 47.43,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.92875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.105,
    y: 57.394999999999996,
    fontFamily: "Arial"
  }, "\n        Iroquois\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 331.2,
    y: 33.68,
    width: 49.94,
    height: 47.43,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.905
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 356.16999999999996,
    y: 57.394999999999996,
    fontFamily: "Arial"
  }, "\n        Saline\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 381.14,
    y: 33.68,
    width: 50.3,
    height: 47.43,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.905
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 406.28999999999996,
    y: 57.394999999999996,
    fontFamily: "Arial"
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 431.44,
    y: 33.68,
    width: 51.92,
    height: 47.43,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.743
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 457.4,
    y: 57.394999999999996,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 483.35,
    y: 33.68,
    width: 52.69,
    height: 47.43,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.905
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 509.69500000000005,
    y: 57.394999999999996,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 536.04,
    y: 33.68,
    width: 53.7,
    height: 47.43,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.775714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.89,
    y: 57.394999999999996,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 589.74,
    y: 33.68,
    width: 54.96,
    height: 47.43,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.905
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 617.22,
    y: 57.394999999999996,
    fontFamily: "Arial"
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 644.7,
    y: 33.68,
    width: 55.3,
    height: 47.43,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 672.35,
    y: 57.394999999999996,
    fontFamily: "Arial"
  }, "\n        Christian\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.84,
    y: 81.11,
    width: 57.36,
    height: 46.52,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.304
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 92.52000000000001,
    y: 104.37,
    fontFamily: "Arial"
  }, "\n        Coles\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.84,
    y: 127.63,
    width: 57.36,
    height: 46.59,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.659000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 92.52000000000001,
    y: 150.925,
    fontFamily: "Arial"
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.84,
    y: 174.22,
    width: 57.36,
    height: 46.61,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.658571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 92.52000000000001,
    y: 197.525,
    fontFamily: "Arial"
  }, "\n        McHenry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.84,
    y: 220.83,
    width: 57.36,
    height: 46.69,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.187777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 92.52000000000001,
    y: 244.175,
    fontFamily: "Arial"
  }, "\n        Whiteside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.84,
    y: 267.52,
    width: 57.36,
    height: 48.33,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.055
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 92.52000000000001,
    y: 291.685,
    fontFamily: "Arial"
  }, "\n        Bureau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.84,
    y: 315.85,
    width: 57.36,
    height: 50.63,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.063000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 92.52000000000001,
    y: 341.165,
    fontFamily: "Arial"
  }, "\n        Stephenson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.84,
    y: 366.47,
    width: 57.36,
    height: 51.66,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.61
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 92.52000000000001,
    y: 392.3,
    fontFamily: "Arial"
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.84,
    y: 418.14,
    width: 57.36,
    height: 52.78,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.5975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 92.52000000000001,
    y: 444.53,
    fontFamily: "Arial"
  }, "\n        Tazewell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.84,
    y: 470.91,
    width: 57.36,
    height: 55.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.128
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 92.52000000000001,
    y: 498.73,
    fontFamily: "Arial"
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.84,
    y: 526.56,
    width: 57.36,
    height: 55.81,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.581
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 92.52000000000001,
    y: 554.4649999999999,
    fontFamily: "Arial"
  }, "\n        Williamson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.84,
    y: 582.37,
    width: 57.36,
    height: 58.38,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 92.52000000000001,
    y: 611.5600000000001,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.84,
    y: 640.74,
    width: 57.36,
    height: 59.26,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 92.52000000000001,
    y: 670.37,
    fontFamily: "Arial"
  }, "\n        Macoupin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 81.11,
    width: 52.34,
    height: 68.1,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.5425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.37,
    y: 115.16,
    fontFamily: "Arial"
  }, "\n        Kankakee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.54,
    y: 81.11,
    width: 52.61,
    height: 68.1,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.1525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.845,
    y: 115.16,
    fontFamily: "Arial"
  }, "\n        Knox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.15,
    y: 81.11,
    width: 65.6,
    height: 68.1,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.288888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.95,
    y: 115.16,
    fontFamily: "Arial"
  }, "\n        Champaign\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.75,
    y: 81.11,
    width: 66.86,
    height: 68.1,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.372
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 325.18,
    y: 115.16,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358.61,
    y: 81.11,
    width: 75.73,
    height: 68.1,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 396.475,
    y: 115.16,
    fontFamily: "Arial"
  }, "\n        McLean\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 434.34,
    y: 81.11,
    width: 83.07,
    height: 68.1,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.62
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 475.875,
    y: 115.16,
    fontFamily: "Arial"
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 517.41,
    y: 81.11,
    width: 85.88,
    height: 68.1,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.3499999999999,
    y: 115.16,
    fontFamily: "Arial"
  }, "\n        Vermilion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 603.29,
    y: 81.11,
    width: 96.71,
    height: 68.1,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 651.645,
    y: 115.16,
    fontFamily: "Arial"
  }, "\n        DuPage\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 149.21,
    width: 92.94,
    height: 72.01,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.546363636363637
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 167.67000000000002,
    y: 185.215,
    fontFamily: "Arial"
  }, "\n        Rock_Island\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 221.22,
    width: 92.94,
    height: 72.13,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.014444444444443
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 167.67000000000002,
    y: 257.28499999999997,
    fontFamily: "Arial"
  }, "\n        Winnebago\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 293.35,
    width: 92.94,
    height: 72.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 167.67000000000002,
    y: 329.8,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 366.25,
    width: 92.94,
    height: 73.62,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.517142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 167.67000000000002,
    y: 403.06,
    fontFamily: "Arial"
  }, "\n        LaSalle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 439.86,
    width: 92.94,
    height: 80.85,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.2125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 167.67000000000002,
    y: 480.285,
    fontFamily: "Arial"
  }, "\n        Will\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 520.72,
    width: 92.94,
    height: 88.55,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 167.67000000000002,
    y: 564.995,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 609.26,
    width: 92.94,
    height: 90.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.685
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 167.67000000000002,
    y: 654.63,
    fontFamily: "Arial"
  }, "\n        Kane\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.15,
    y: 149.21,
    width: 149.61,
    height: 58.28,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 288.95500000000004,
    y: 178.35000000000002,
    fontFamily: "Arial"
  }, "\n        Sangamon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 363.76,
    y: 149.21,
    width: 157.2,
    height: 58.28,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.713333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 442.36,
    y: 178.35000000000002,
    fontFamily: "Arial"
  }, "\n        Peoria\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 520.96,
    y: 149.21,
    width: 179.04,
    height: 58.28,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.475555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 610.48,
    y: 178.35000000000002,
    fontFamily: "Arial"
  }, "\n        St._Clair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.15,
    y: 207.49,
    width: 485.85,
    height: 492.51,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 121.4625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 457.07500000000005,
    y: 453.745,
    fontFamily: "Arial"
  }, "\n        Cook\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1932);
export default __webpack_public_path__ + "static/media/1932.6170e20194d421df85ecf1650440110d.svg";
export { ForwardRef as ReactComponent };